import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  paymentsTab: {
    //
  }
});

export default styles;
